// removed by extract-text-webpack-plugin
module.exports = {"videoWrapper":"src-components-project-project-video----project-video-module---videoWrapper---3zMwq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-video/project-video.module.css
// module id = 538
// module chunks = 140935043865547